import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/styles';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import { ModalWelcome } from './styles';

const ModalTour = ({ open, setRun, pathImg, conteudo, isWelcomeInicial }) => {
  const style = ModalWelcome();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [, setModalWelcomeInicial] = useContext(GlobalContext).modalWelcomeInicial;
  const [, setModalVisaoGeral] = useContext(GlobalContext).modalVisaoGeral;

  return (
    <Dialog open={open} onClose={() => {}} fullScreen={fullScreen} fullWidth maxWidth="md">
      <DialogContent style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        <>
          <div style={{ float: 'left' }}>
            <img className={isWelcomeInicial ? style.primeiraImagem : style.segundaImagem} src={pathImg} alt="tour" />
          </div>

          <div>
            <div className={`${style.divParagrafo}`}>
              <p className={style.paragrafo}>{<h2 dangerouslySetInnerHTML={{ __html: conteudo }} />}</p>
            </div>
          </div>
        </>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          style={{ textTransform: 'none' }}
          variant="contained"
          className={style.botaoAvancar}
          onClick={() => {
            if (isWelcomeInicial) {
              setModalWelcomeInicial('');
            } else {
              setModalVisaoGeral('');
            }
            setRun(true);
          }}
        >
          Avançar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalTour;
